import { Injectable } from '@angular/core';
import * as grpcWeb from 'grpc-web';
import { environment } from 'src/environments/environment';
import { LogShared } from '../models/interface/log.interface';
import { GrpcFactoryService } from './grpc-factory.service';
import { LogServiceClient } from '../api/logs/logs.apiServiceClientPb';
import { LogFields, LogRequest, LogResponse } from '../api/logs/logs.api_pb';

@Injectable({
  providedIn: 'root',
})
export class LogsService {
  private hostUrlBack: string;
  private logsClient: LogServiceClient;
  private logRequest: LogRequest;

  constructor(grpcFactoryService: GrpcFactoryService) {
    this.hostUrlBack = environment.hostname + environment.hostPort;
    this.logsClient = grpcFactoryService.create(LogServiceClient, this.hostUrlBack, 'LogServiceClient');
    this.logRequest = new LogRequest();
  }

  /**
   * method to save log
   *
   * @param {logShared} log Log data
   */
  async buildLog(log: LogShared): Promise<void> {
    if (environment.shared.disableAllLogs) {
      return environment.guardClause;
    }

    return this.addLog(log);
  }

  /**
   * method to save log
   *
   * @param {logShared} log Log data
   */
  addLog(log: LogShared): Promise<void> {
    return new Promise((resolve, reject) => {
      this.setParams(log);
      this.logsClient.addLog(this.logRequest, {}, (err: grpcWeb.Error, response: LogResponse) => {
        if (err) {
          return reject(err);
        }

        resolve();
      });
    });
  }

  /**
   * method to save log
   *
   * @param {logShared} log Log data
   */
  setParams(log: LogShared): void {
    this.logRequest.setName(log.name);
    this.logRequest.setDescription(log.description);
    this.logRequest.setCreatedat(new Date().getTime());
    this.logRequest.setUpdatedat(new Date().getTime());
    this.logRequest.setReportedby(log.reportedBy);
    const logFieldList: LogFields[] = [];

    for (const logField of log.logFieldList) {
      const newLogField: LogFields = new LogFields();
      newLogField.setField(logField.field);
      newLogField.setValue(logField.value);
      newLogField.setDatatype(logField.dataType);
      logFieldList.push(newLogField);
    }

    this.logRequest.setFieldsList(logFieldList);
  }
}
